module.exports = __webpack_public_path__ + "img/no-select-season.03adba30.png";